$(document).ready(function () {
	$.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function () {
		quickView()
	})
});

function quickView() {
	$(".quick-view").click(function () {
		console.log($("#quick-view"));
		if ($("#quick-view").length == 0) {
			$('body').append('<div id="quick-view"></div>');
		}

		const handle = $(this).data("handle");

		$('#quick-view').addClass('active');

		$.getJSON(`/products/${handle}.js`, function (data) {
			const { title, description, images, tags } = data;

			const quickViewElement = `
				<div id="quick-view">
					<div class='rowx'>
						<div class='halfx'>
							<div class='pro-top'>
								<div class="qv-product-images"></div>
							</div>
			
							<h3 class="mobile qv-product-title">${title}</h3>
							<hr class='mobile'>

							<div class='pro-bottom'>
								<p>Nährwert</p>

								<div class='nutrients content'></div>
								<p>Zutaten</p>
								<div class='ads'></div>
							</div>
						</div>
			
						<div class='halfy'>
							<div class="qv-content">
								<div class="holder">
									<h3 class="desktop qv-product-title">${title}</h3>
									<div class="qv-product-description">${description}</div>
								</div>
							</div>
						</div>
				</div>`;

			$.fancybox({
				href: "#quick-view",
				maxWidth: 900,
				maxHeight: 900,
				fitToView: !1,
				width: "65%",
				height: "90%",
				autoSize: !1,
				closeClick: !1,
				openEffect: "none",
				closeEffect: "none",
				beforeLoad: function () {

				},
				afterShow: function () {
					const modal = $("#quick-view");
					modal.html(quickViewElement);
					modal.css("opacity", "1");

					$('.qv-product-images').append(`<img src="${images[1]}" />`);

					tags.forEach(tag => {
						$(".nutrients").append("<div class='cnt'>" + tag + "</div>")
					});

					images.splice(0, 2);

					images.forEach(image => {
						$(".ads").append("<img class='info-m' src=" + image + ">");
					});

					modal.fadeIn(function () {
						$(".qv-product-images").addClass("loaded")
					});

					$('.showID').text(handle)
				},

				afterClose: function () {
					$("#quick-view").removeClass().empty()
				}
			})
		});
	});
}